import React, { HTMLAttributes } from 'react';
// import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import MuiTextField from '@mui/material/TextField';
import { TextFieldProps } from '@mui/material/TextField';

// type ITextFieldControl = InputTypeMap<{}, 'TextField'>;

// export type ITextFieldProps = HTMLAttributes<HTMLInputElement> & ITextFieldControl['props'];

// type IInputProps = {
//     // min?: string;
//     // max?: string;
//     // maxLength?: string;
//     // inputSize?: string;
//     inputProps?: HTMLAttributes<HTMLInputElement>;
// };

export type ITextFieldProps = {
    pattern?: string;
    accept?: string;
} & TextFieldProps;

// import { Expand, ExpandRecursively } from '../../interfaces/TypeHelper';
// type ExpandedType = Expand<HTMLInputElement>;

const TextField: React.FC<React.PropsWithChildren<ITextFieldProps>> = ({ fullWidth, inputProps, InputProps, defaultValue, pattern, ...props }) => {
    const InputLabelProps = {
        shrink: props?.type === 'date' ? true : undefined,
    };

    inputProps = { ...inputProps, accept: props.accept, pattern, autoComplete: inputProps?.autocomplete as string || props?.autoComplete || undefined };

    return (
        <MuiTextField
            {...props}
            InputLabelProps={InputLabelProps}
            defaultValue={defaultValue}
            fullWidth={fullWidth === false ? false : true}
            inputProps={inputProps} // props for HTML <input> element e.g. autoComplete, data-da-el-name
            InputProps={InputProps} // mui Props e.g. startAdornment
        />
    );
};

export default TextField;
